<template>
    <div class="d-flex align-items-center">
        <label for="entriesPerPage" class="me-2 mt-2">Show</label>
        <select id="entriesPerPage" v-model="perPage" @change="updatePerPage" class="form-select form-select-sm" style="width: auto">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
        </select>
        <span class="ms-2">Showing 1 to {{perPage}} of {{total}} entries</span>
    </div>
</template>
<script>
export default {
    props: {
        componentName: {
            type: String,
            required: true,
        },
        total: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            perPage: 10,
        };
    },
    methods: {
        updatePerPage() {
            // Emit the updated perPage value to the parent component
            this.$emit('update-per-page-'+this.componentName, this.perPage);
        },
    },
};
</script>